/* istanbul ignore file */
import client, { ApiVersion } from '../client'
import ScheduleMapper, { SchedulePayload } from '@web/mapper/ScheduleMapper'
import HeaderMapper from '@web/mapper/HeaderMapper'

export default class Schedule {
  static fetch () {
    return client.get('/schedule', { apiVersion: ApiVersion.v2 })
      .then((response) => ({
        data: response.data.data.map(ScheduleMapper.toClient),
        headers: HeaderMapper.toClient(response.headers)
      }))
  }

  static create (payload: SchedulePayload) {
    return client.post('/schedule', ScheduleMapper.toServer(payload), ApiVersion.v2, true)
      .then((response) => {
        if (response.data.errors?.length) {
          throw { errors: response.data.errors } // eslint-disable-line
        }
        return { data: ScheduleMapper.toClient(response.data.data) }
      })
  }

  static update (id: number, payload: SchedulePayload) {
    return client.put(`/schedule/${id}`, ScheduleMapper.toServer(payload), ApiVersion.v2, true)
      .then((response) => {
        if (response.data.errors?.length) {
          throw { errors: response.data.errors } // eslint-disable-line
        }
        return { data: ScheduleMapper.toClient(response.data.data) }
      })
  }

  static toggleEnabled (id: number, isEnabled: boolean) {
    return client.patch(`/schedule/${id}/enabled`, { isEnabled }, ApiVersion.v2)
      .then((response) => ({ data: ScheduleMapper.toClient(response.data.data) }))
  }

  static remove (id: number) {
    return client.delete(`/schedule/${id}`, ApiVersion.v2)
  }
}
